import CRUDService from "./geral/CRUDService";
import {http} from "../config/Constantes";

export default class SolicitacaoService extends CRUDService{
    constructor() {
        super("solicitacao");
    }

    listRascunhos() {
        return http.get("/"+this.serviceName+"/rascunho")
    }

    carregarRascunho(idSolicitacao) {
        return http.get("/"+this.serviceName+"/rascunho/"+idSolicitacao);
    }

    carregarSolicitacao(idSolicitacao) {
        return http.get("/"+this.serviceName+"/detalhes/"+idSolicitacao);
    }

    carregarDetalhesSolicitacaoByEttId(idSolicitacaoEtt) {
        return http.get("/"+this.serviceName+"/detalhesContratacao/"+idSolicitacaoEtt);
    }

    salvarRascunho(solicitacao) {
        return http.post("/"+this.serviceName+"/salvar", solicitacao)
    }

    excluirRascunho(solicitacao) {
        return http.post("/"+this.serviceName+"/rascunho/delete", solicitacao);
    }

    // enviar(solicitacao) {
    //     return http.post("/"+this.serviceName+"/enviar", solicitacao)
    // }

    get(taskIdBpm) {
        return http.get("/"+this.serviceName+"/"+taskIdBpm)
    }

    // anteciparTermino(solicitacaoEttId, dataFinalAntecipada, razao) {
    //     return http.post("/"+this.serviceName+"/antecipada/iniciar", {solicitacaoEttId: solicitacaoEttId, dataFinalAntecipada: dataFinalAntecipada, razao:razao} );
    // }

    // anteciparTerminoFinalizandoFluxoSubstituicao(solicitacaoEttId, dataFinalAntecipada, razao, taskIdTarefaSubstituicao, solicitacaoSubstituicaoId ) {
    //     return http.post("/"+this.serviceName+"/antecipada/iniciar", {solicitacaoEttId: solicitacaoEttId, dataFinalAntecipada: dataFinalAntecipada, razao:razao, taskIdTarefaSubstituicao: taskIdTarefaSubstituicao, solicitacaoSubstituicaoId: solicitacaoSubstituicaoId} );
    // }

    // prorrogar(solicitacaoProrrogacao) {
    //     return http.post("/prorrogacao", solicitacaoProrrogacao);
    // }

    prorrogacoesAnteriores(idSolicitacaoEtt) {
        return http.get("/prorrogacao/anteriores/ett/" +idSolicitacaoEtt);
    }

    migrar(solicitacaoMigracao){
        return http.post("/alocacao/migrarProduto", solicitacaoMigracao);
    }

    carregarDadosMigracao(idEtt){
        return http.get("/alocacao/alocacoesMot/"+idEtt);
    }

    carregarDetalhesSolicitacaoBySubstituicaoId(substituicaoId) {
        return http.get("/substituicao/"+substituicaoId);
    }

    carregarDetalhesSolicitacaoByProrrogacaoId(solicitacaoEttId, prorrogacaoId) {
        return http.get("/prorrogacao/"+solicitacaoEttId+"/"+prorrogacaoId);
    }

    carregarDetalhesSolicitacaoByTerminoAntecipadoId(solicitacaoEttId, terminoAntecipadoId) {
        return http.get("/solicitacao/antecipada/"+solicitacaoEttId+"/"+terminoAntecipadoId);
    }

    obterUrlSolicitacaoRetroativa(solicitacaoEttId, tipo) {
        return http.get("/solicitacao/url-retroativa/"+solicitacaoEttId+"/"+tipo);
    }

    verificaSeExisteCargoNoPcp(cargoId) {
        return http.get("/"+this.serviceName+"/verificaSeExisteCargoNoPcp?cargoId="+cargoId);
    }

    //RHFPP-612 - Atualizar Gestor Solicitante
    carregarSolicitacoesGestorSolicitante(matriculaGestor) {
        return http.get("/"+this.serviceName+"/solicitacoes-gestor/" + matriculaGestor);
    }
    //RHFPP-612 - Atualizar Gestor Solicitante
    atualizarGestorSolicitacao(request){
        return http.post("/"+this.serviceName+"/atualizar-gestor-solicitacao", request)
    }
    // Migrar Produto
    carregarAlocacoesProdutoMot(solicitacaoEttId){
        return http.get("/alocacao/alocacoes-produto-mot/"+solicitacaoEttId);
    }

    obterContatoAtualPorEmail(email) {
        return http.get("/"+this.serviceName+"/contato/" + email);
    }

    getHistorico(tipoFluxo, idSolicitacao){
        return http.get("/"+this.serviceName+"/historico/"+ tipoFluxo + "/"+idSolicitacao);
    }

    sincronizarMediaPulse(idContrato) {
        return http.post("/alocacao/sincronizar-mediapulse", { contratoId: idContrato })
    }    
}